import React from 'react';
import { Modal, Container, Row, Col} from 'react-bootstrap';

const ContactInfo = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable className="contact-info-modal">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold display-6">
          Contact <span className="text-primary">Apex</span> Enterprises
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        <Container>
          <Row className="g-4">
            <Col lg={5}>
              <div className="contact-details-card h-100">
                <h3 className="fw-bold mb-4">Get in Touch</h3>
                
                <div className="d-flex mb-4 align-items-start">
                  <div className="contact-icon-box bg-primary bg-opacity-10 text-primary rounded-3 p-3 me-3">
                    <i className="fas fa-map-marker-alt fa-lg"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1">Our Office</h5>
                    <p className="text-muted mb-0">576, Kanchan Apts., Behind Sai Service Station, Deccan Gymkhana, Pune-411004</p>
                  </div>
                </div>

                <div className="d-flex mb-4 align-items-start">
                  <div className="contact-icon-box bg-primary bg-opacity-10 text-primary rounded-3 p-3 me-3">
                    <i className="fas fa-phone-alt fa-lg"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1">Call Us</h5>
                    <p className="mb-0">
                      <a href="tel:9518727785" className="text-decoration-none text-muted hover-primary">9518727785</a> / <a href="tel:9890417096" className="text-decoration-none text-muted hover-primary">9890417096</a> / <a href="tel:9022117394" className="text-decoration-none text-muted hover-primary">9022117394</a>
                    </p>
                  </div>
                </div>

                <div className="d-flex mb-4 align-items-start">
                  <div className="contact-icon-box bg-primary bg-opacity-10 text-primary rounded-3 p-3 me-3">
                    <i className="fas fa-envelope fa-lg"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1">Email Us</h5>
                    <p className="mb-0">
                      <a href="mailto:apexenterprises1966@gmail.com" className="text-decoration-none text-muted hover-primary">apexenterprises1966@gmail.com</a>
                    </p>
                  </div>
                </div>

                <div className="d-flex mb-4 align-items-start">
                  <div className="contact-icon-box bg-primary bg-opacity-10 text-primary rounded-3 p-3 me-3">
                    <i className="fas fa-clock fa-lg"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1">Working Hours</h5>
                    <p className="text-muted mb-0">Mon-Fri: 8AM - 6PM<br />Sat: 9AM - 2PM</p>
                  </div>
                </div>

                <hr className="my-4" />

                {/* <h5 className="fw-bold mb-3">Follow Our Work</h5>
                <div className="d-flex gap-3">
                  <a href="#" className="social-btn bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#" className="social-btn bg-info text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#" className="social-btn bg-danger text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#" className="social-btn bg-primary bg-gradient text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div> */}
              </div>
            </Col>
            
            <Col lg={7}>
              <div className="map-container rounded-4 overflow-hidden shadow-sm border" style={{ height: '450px' }}>
                
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7823.256426289588!2d73.83686427502732!3d18.516814399038562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bff8788ba2c5%3A0x616085924bb265d8!2sApex%20Enterprises!5e0!3m2!1sen!2sin!4v1774611294349!5m2!1sen!2sin" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Apex Enterprises Location"
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default ContactInfo;